
export function getAuthHeaders(access_token?: string){
  
    // Headers
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': '',
      },
    };
  
    // If token, add to headers config
    if (access_token) {
      config.headers['Authorization'] = `Bearer ${access_token}`;
    }
  
    return config;
  }
  
export const SUPPORT_PHONE = '877-686-8550';
export const SUPPORT_HOURS = 'between the hours of 8:00 AM and 4:30 PM Monday through Friday';

export const PLEASE_CALL_MESSAGE = `Please call us at ${SUPPORT_PHONE} ${SUPPORT_HOURS} ` +
   '(Central Time) or email us at info@inframarker.com for assistance.';

// Backend refuses portal use for organizations at the 'None' portal data level
export const PORTAL_ACCESS_DENIED_ERROR = 'portal_access_denied';
export const API_NOT_PERMITTED_DETAIL = 'This account is not permitted to use the API.';
export const PORTAL_ACCESS_DENIED_MESSAGE = 'Your organization does not have access to the InfraMarker Portal. ' + PLEASE_CALL_MESSAGE;

export const ORG_ACCESS_DENIED_MESSAGE = 'You do not have access to this organization\'s data. ' + PLEASE_CALL_MESSAGE;

// Org-scoped endpoints return 403 for organizations the user may not view
export function orgRequestErrorMessage(error: any, fallback: string) {
   return error?.response?.status === 403 ? ORG_ACCESS_DENIED_MESSAGE : fallback;
}
